export const getServerUrl = () =>
  process.env.NEXT_PUBLIC_API_URL?.replace('/api', '') || 'http://localhost:5000';

export interface ImageOptions {
  /** Cap the delivered width in px (downscale only, aspect ratio preserved). */
  width?: number;
  /** Cloudinary quality. Defaults to 'auto' (intelligent compression). */
  quality?: number | 'auto';
}

// Inject Cloudinary delivery optimizations (auto format -> AVIF/WebP, auto quality,
// optional width cap) so we ship far fewer bytes without changing how images look.
// Non-Cloudinary URLs and already-transformed URLs are returned unchanged.
function optimizeCloudinary(url: string, opts: ImageOptions): string {
  if (!url.includes('res.cloudinary.com') || !url.includes('/upload/')) return url;

  const [base, rest] = url.split('/upload/');
  const firstSegment = rest.split('/')[0];

  // Bail out if the URL already carries explicit transformations, to avoid stacking.
  if (/(^|,)(f_|q_|w_|c_)/.test(firstSegment)) return url;

  const transforms = ['f_auto', `q_${opts.quality ?? 'auto'}`];
  if (opts.width) transforms.push(`w_${opts.width}`, 'c_limit');

  return `${base}/upload/${transforms.join(',')}/${rest}`;
}

export const getImageUrl = (path: string, opts: ImageOptions = {}) => {
  if (!path) return '';
  const url = path.startsWith('http') ? path : `${getServerUrl()}${path}`;
  return optimizeCloudinary(url, opts);
};
